import style from '@pages/front/pages/examCenter/style/ExamList.module.less';
import {gradeRecord} from '@/utils/const';
import {Divider} from 'antd';
import format from 'dayjs';
import Icon from '@/common/Icon';
import {hasPermission} from '@/utils';

export interface ExamItemHeaderProps extends Exam {
    toExamAdd?:(prop: Exam) => void;
    deleteFn?:(prop: Exam) => void;
    hideBtn?: boolean;
}
export const ExamItemHeader: React.FC<ExamItemHeaderProps> = props => {
  return (
    <div className={style.examItemHeader}>
      <img src={require('@/assets/imgs/examCenter/exam.svg').default} alt="" />
      <div className={style.middle}>
        <div>{props.name}</div>
        <div>
          <span>{gradeRecord[props.gradeDcode]}</span>
          <Divider type="vertical" />
          <span>{format(props.examDate).format('YYYY-MM-DD')}</span>
          <Divider type="vertical" />
          <span>共{props.schoolCount || props.schools?.length}个学校</span>
        </div>
      </div>
      <div className={`${props.hideBtn ? style.hide : ''}`}>
        {hasPermission('EXAM:ADD_UPDATE') &&
            <>
              <span>
                <Icon disabled={props.archive} type="icon-xiugai1"
                  onClick={() => props.toExamAdd && props.toExamAdd(props)}>编辑</Icon>
              </span>
              <span>
                <Icon onClick={() => props.deleteFn && props.deleteFn(props)} type="shanchu"
                  disabled={props.stuPresentCount > 0 || props.archive}>删除</Icon>
              </span>
            </>
        }
      </div>
    </div>
  );
};

export default ExamItemHeader;
